import { FormNotice } from '@zappyrent/hundop';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { useEffect } from 'react';

import TelephoneInput from '../../___design/TelephoneInput';
import TextInput from '../../___design/TextInput';
import {
  StyledContainer,
  StyledFieldList,
  StyledFieldListItem,
} from './UserInfoFormFields.styles';
import { UserInfoFieldsProps } from './UserInfoFormFields.types';
import { convertFieldsToObject } from './utils/convertFieldToObject';
import { filterMissingInfoForPersonalInformation } from './utils/filterMissingInfoForPersonalInformation';

const UserInfoFields = ({
  user,
  onChange,
  setMissingPersonalInformation,
  fields,
  setFields,
}: UserInfoFieldsProps): JSX.Element | null => {
  const hasFieldErrors = (name: string, value: string) => {
    if ((name === 'phone_no' && !isValidPhoneNumber(value)) || !value) {
      return true;
    }
    return false;
  };

  const handleInputChange = (name: string, value: string) => {
    const hasErrors: boolean = hasFieldErrors(name, value);
    const updatedFields = fields.map(item =>
      item.name === name
        ? { ...item, isEditing: true, hasErrors, value }
        : { ...item },
    );
    setFields(updatedFields);
    const updatedUser: { [x: string]: string | { [x: string]: string } } = {};
    if (name === 'phone_no') {
      updatedUser[name] = value.split(' ').join('');
    } else if (
      name === 'id_document_number' ||
      name === 'id_document_expiry_date'
    ) {
      updatedUser['id_document'] = {
        ...(name === 'id_document_number' && { number: value }),
        ...(name === 'id_document_expiry_date' && { expiry_date: value }),
      };
    } else {
      updatedUser[name] = value;
    }

    onChange(updatedUser);
  };

  useEffect(() => {
    const fieldToObject = convertFieldsToObject(fields);
    const missingValue = filterMissingInfoForPersonalInformation({
      values: fieldToObject,
    });
    setMissingPersonalInformation(missingValue);
  }, [fields]);

  if (user) {
    return (
      <StyledContainer>
        <StyledFieldList>
          {fields.map(item => {
            const {
              errorLabel,
              hasErrors,
              isEditing,
              label,
              name,
              type,
              value,
            } = item;

            return (
              <StyledFieldListItem key={name}>
                {type === 'tel' ? (
                  <TelephoneInput
                    id={name}
                    label={label}
                    name={name}
                    value={value as string}
                    onChange={value => handleInputChange(name, value)}
                  >
                    {isEditing && hasErrors && (
                      <FormNotice isWrapped>{errorLabel}</FormNotice>
                    )}
                  </TelephoneInput>
                ) : (
                  <TextInput
                    id={name}
                    label={label}
                    name={name}
                    type={type}
                    value={value as string}
                    onChange={event =>
                      handleInputChange(name, event.target.value)
                    }
                  >
                    {isEditing && hasErrors && (
                      <FormNotice isWrapped>{errorLabel}</FormNotice>
                    )}
                  </TextInput>
                )}
              </StyledFieldListItem>
            );
          })}
        </StyledFieldList>
      </StyledContainer>
    );
  }

  return null;
};

export default UserInfoFields;
